module.exports = __webpack_public_path__ + "img/no_bankCard@2x.4e43a7ed.png";